import { usePrimeVue, type PrimeVueConfiguration } from 'primevue/config'
import { de } from 'primelocale/de.json'
import { en } from 'primelocale/en.json'
import { hu } from 'primelocale/hu.json'
import { tr } from 'primelocale/tr.json'
import { uk } from 'primelocale/uk.json'

export default defineNuxtPlugin({
  dependsOn: ['i18n:plugin'],

  setup(app) {
    const primevue = usePrimeVue()

    const currentLocale = useNuxtApp().$i18n.locale.value
    updateLocale(currentLocale, primevue)

    app.hook('i18n:beforeLocaleSwitch', ({ newLocale }) => {
      updateLocale(newLocale, primevue)
    })
  },
})

function updateLocale(newLocale: LocaleType, primevue: { config: PrimeVueConfiguration }) {
  if (newLocale === 'de') {
    primevue.config.locale = de
  }
  if (newLocale === 'en') {
    primevue.config.locale = en
  }
  if (newLocale === 'hu') {
    primevue.config.locale = hu
  }
  if (newLocale === 'tr') {
    primevue.config.locale = tr
  }
  if (newLocale === 'uk') {
    primevue.config.locale = uk
  }
}
